import React, { Component } from "react";

//routing
import {
    withRouter,
} from "react-router-dom";

//generic functions
import {
    isEmpty
} from "../../../functions/generic_functions";

//cari_components/CariLoginPanel
//views
import CariLoginPanel from "../../../cari/js/components/cari_components/CariLoginPanel";


/*
    props {
        navBarOptions: [
            {
                label: "something",
                url: "some location"
            }
        ]
        callBackBeforeRedirectPgFunc => call back function before page redirect do this, then redirect.
    }
*/
class NavSideBar extends Component {

    constructor(props) {
        super(props);

        //helper fucntions
        this.highLightCurrentPage = this.highlightCurrentPage.bind(this);

        //action handlers
        this.handleOnClickLink = this.handleOnClickLink.bind(this);
    }

    /* returns yellow selected class on selected link with strong */
    highlightCurrentPage(url) {
        var currentUrl = window.location.pathname;

        //check which url it corresponds to
        if (currentUrl === url) {
            return "navbar_curr_page_text";
        }
        else {
            return "";
        }
    }


    handleOnClickLink(event, nextUrl) {
        //prevent link from changing on a
        event.preventDefault();

        //on page click link do something, then redirect to the specified url
        if (!isEmpty(this.props.callBackBeforeRedirectPgFunc)) {
            this.props.callBackBeforeRedirectPgFunc(nextUrl, (nextUrl) => {
                this.props.history.push(nextUrl);
            })
        }
        //if the function doesnt exist, redirect
        else {
            this.props.history.push(nextUrl);
        }
    }

    render() {
        return (
            <div className="navbar_width">
                <div className="default-nav no_left_right_padding">
                    <div className="nav-control">
                        <button className="navtoggle-btn btn">Nav</button>
                    </div>
                    
                    <div className="cursor_pointer">
                        {(!isEmpty(this.props.navBarOptions) ?  this.props.navBarOptions.map(function (data, i) {
                            return (
                                <a 
                                    key={i}
                                    onClick={(e,) => this.handleOnClickLink(e, data.url)}
                                >
                                    <span className={"navbar_text " + this.highLightCurrentPage(data.url)}>
                                        {data.label}
                                    </span>
                                </a>
                            );
                        }.bind(this))
                        : null)}
                    </div>    
            
                    <div className="nav_bar_sign_out">
                        <span>
                            <CariLoginPanel />
                        </span>
                    </div>
                </div>    
                
            </div>
        );
    }
}
export default withRouter(NavSideBar);
